export default {
  data: {
    page: {
      theme: {
        logo: "red",
        type: "default",
      },
      title: "APIs are not enough",
      content:
        '\n<p><em>As the tide of modernization threatens to sweep away even the most firmly established enterprises, executives are pouring millions into developing APIs. But just investing in connective technologies isn’t enough &#8211; to maximize the true value of their data, firms need to adopt a new paradigm.</em></p>\n\n\n\n<p><strong>A New Paradigm</strong></p>\n\n\n\n<p>IT departments, formerly a support system otherwise disconnected from their company’s business goals, are now responsible for facilitating the organization’s crucial integration into market ecosystems. To survive and compete in this new ecosystem economy, companies need to develop a new paradigm that intentionally closes the gap between IT and business.&nbsp;</p>\n\n\n\n<p>That paradigm begins with a shift in intent. Successful APIs are fully productized, with equal emphasis on development, adoption, and growth. Rather than taking an ad-hoc approach, companies need to infuse their API initiatives with an early intent to drive involvement in the many internal and external ecosystems enabled by their data:</p>\n\n\n\n<figure class="wp-block-pullquote is-style-default"><blockquote><p>Application programming interfaces (APIs) have been elevated from a development technique to a business model driver and boardroom consideration. An organization’s core assets can be reused, shared, and monetized through APIs that can extend the reach of existing services or provide new revenue streams. </p><cite><a href="https://www2.deloitte.com/content/dam/Deloitte/us/Documents/financial-services/us-fsi-api-economy.pdf">Deloitte</a></cite></blockquote></figure>\n\n\n\n<div class="wp-block-group"><div class="wp-block-group__inner-container">\n<p>The new approach to data monetization requires full integration, built to account for the needs of all relevant departments in the context of well-defined business goals. No longer the domain of isolated IT teams, the modern API strategy is comprehensive and company-wide.&nbsp;</p>\n\n\n\n<p>By embracing the global shift towards collaboration and integration as a core principle of their API design and implementation philosophy, firms can create new revenue streams, increase productivity, form partnerships, and expand their user bases.</p>\n</div></div>\n',
      uri: "/insights/apis-are-not-enough/",
      date: "December 25, 2020",
      modifiedGmt: "2021-02-08T22:48:22",
      slug: "apis-are-not-enough",
      author: {
        node: {
          name: "Vivid",
        },
      },
      seo: {
        canonical: "",
        metaDesc: "Your guide to successfully adapting to the new economy",
        opengraphDescription: "Your guide to successfully adapting to the new economy",
        opengraphImage: {
          localFile: {
            publicURL: "/static/ed2e332607eab8f7f114b509efa52052/0F0A2297-1.jpg",
          },
          mediaDetails: {
            width: 900,
            height: 538,
          },
          altText: "",
        },
        opengraphSiteName: "Vivid",
        opengraphTitle: "APIs are not enough - Vivid",
        opengraphType: "article",
        title: "APIs are not enough - Vivid",
        twitterDescription: "",
        twitterTitle: "",
        twitterImage: null,
      },
      baseFields: {
        previewDescription: "Adopting a new paradigm for success. ",
        previewImage: {
          altText: "v4",
          localFile: {
            childImageSharp: {
              fluid: {
                base64:
                  "data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAMABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAQCAwX/xAAVAQEBAAAAAAAAAAAAAAAAAAABAv/aAAwDAQACEAMQAAAB3UHlyriAz//EABoQAQEAAgMAAAAAAAAAAAAAAAEDAAIQETL/2gAIAQEAAQUCyl0sPfFvGoB//8QAFxEBAAMAAAAAAAAAAAAAAAAAAQIQMf/aAAgBAwEBPwGKG1//xAAVEQEBAAAAAAAAAAAAAAAAAAABEP/aAAgBAgEBPwFn/8QAGRAAAgMBAAAAAAAAAAAAAAAAAAECEBFB/9oACAEBAAY/AhQSvemI/8QAGhAAAwEAAwAAAAAAAAAAAAAAAAERIRBRYf/aAAgBAQABPyEQm9ohLxmC6US0Yf/aAAwDAQACAAMAAAAQ5w//xAAWEQEBAQAAAAAAAAAAAAAAAAABERD/2gAIAQMBAT8QYYuf/8QAFhEBAQEAAAAAAAAAAAAAAAAAERAh/9oACAECAQE/EEZP/8QAGRABAQEBAQEAAAAAAAAAAAAAAREAIUFx/9oACAEBAAE/EMlY0FXaeYSEfmHrpYHQI6VnNFADf//Z",
                aspectRatio: 1.6712328767123288,
                src: "/static/c6cf65b7458d876fa89f8d5e7df47d2b/85569/v4.jpg",
                srcSet:
                  "/static/c6cf65b7458d876fa89f8d5e7df47d2b/cd2e1/v4.jpg 244w,\n/static/c6cf65b7458d876fa89f8d5e7df47d2b/d4018/v4.jpg 488w,\n/static/c6cf65b7458d876fa89f8d5e7df47d2b/85569/v4.jpg 975w,\n/static/c6cf65b7458d876fa89f8d5e7df47d2b/7fe07/v4.jpg 1463w,\n/static/c6cf65b7458d876fa89f8d5e7df47d2b/9598f/v4.jpg 1799w",
                srcWebp: "/static/c6cf65b7458d876fa89f8d5e7df47d2b/6d50a/v4.webp",
                srcSetWebp:
                  "/static/c6cf65b7458d876fa89f8d5e7df47d2b/9ff39/v4.webp 244w,\n/static/c6cf65b7458d876fa89f8d5e7df47d2b/48eb2/v4.webp 488w,\n/static/c6cf65b7458d876fa89f8d5e7df47d2b/6d50a/v4.webp 975w,\n/static/c6cf65b7458d876fa89f8d5e7df47d2b/d85a6/v4.webp 1463w,\n/static/c6cf65b7458d876fa89f8d5e7df47d2b/1bbe4/v4.webp 1799w",
                sizes: "(max-width: 975px) 100vw, 975px",
                presentationWidth: 975,
              },
            },
          },
        },
      },
      ideaMetaFields: {
        minutesToRead: 3,
      },
      flexchildren: [
        {
          __typename: "RelatedItems",
          heading: "Related Ideas",
          items: null,
        },
      ],
    },
  },
};
